import { render, staticRenderFns } from "./OrderSetView.vue?vue&type=template&id=8fdfe89c&"
import script from "./OrderSetView.vue?vue&type=script&lang=js&"
export * from "./OrderSetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports